import { ApolloError } from '@apollo/client';

import { isApiError } from '../../../types/graphql/error/ApiError';

export default function isManagerRelationshipError(error: ApolloError) {
  return error.graphQLErrors.some(graphQLError => {
    if (!isApiError(graphQLError)) {
      return false;
    }
    return graphQLError.extensions.response?.body?.error?.details?.some(
      (wellFormedDetail: { message?: string }) => {
        // eslint-disable-next-line
        // TODO - we should not be deriving conditional logic from error text. There should be a particular error code
        // returned from the server.
        return (
          wellFormedDetail?.message?.includes(
            'your firm does not have a relationship with a manager on this offering'
          ) || wellFormedDetail?.message?.includes('Investor is not covered by offering manager')
        );
      }
    );
  });
}
